var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAuditLog = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.001,
    height: 18,
    viewBox: "0 0 18.001 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "click",
    transform: "translate(-93.203 -545.767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48641",
    "data-name": "Path 48641",
    d: "M108.8,548.171a8.179,8.179,0,0,0-5.8-2.4h-.014A8.228,8.228,0,0,0,94.756,554a.834.834,0,0,0,.794.794.864.864,0,0,0,.6-.218.834.834,0,0,0,.267-.591,6.573,6.573,0,1,1,6.573,6.573h-.051a.829.829,0,0,0,.02,1.657h.031a8.229,8.229,0,0,0,5.813-14.043Zm-12.754,5.814Z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_47058",
    "data-name": "Path 47058"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43606",
    "data-name": "Group 43606"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48642",
    "data-name": "Path 48642",
    d: "M102.97,549.221A4.776,4.776,0,0,0,98.2,553.8l4.213-1.8a1.938,1.938,0,0,1,.766-.158h0a1.949,1.949,0,0,1,1.789,2.713l-1.8,4.212a4.776,4.776,0,0,0-.2-9.548Z",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_48643",
    "data-name": "Path 48643",
    d: "M103.18,553.168a.636.636,0,0,0-.247.051l-9.351,3.99a.623.623,0,0,0,.05,1.165l3.733,1.232,1.231,3.733a.625.625,0,0,0,.566.427h.026a.624.624,0,0,0,.574-.379l3.989-9.351A.625.625,0,0,0,103.18,553.168Z",
    fill: "#999"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAuditLog);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_audit_log.29d7b2bc357ddb24b6f34891ed157aaf.svg";